import React from "react";

const Confirmation = props => {
  const { returnCallback } = props;
  let { referralType } = props;
  if (!referralType) {
    referralType = "";
  }

  return (
    <div className="container">
      <div className="alert alert-light">
        <p>
          You have <mark>successfully completed the {referralType} referral</mark>{" "}
          and this has been entered into the system.
        </p>
        <p>
          If you would like to enter another {referralType} referral please
          click the button below and you will be directed back to the{" "}
          {referralType} referral page.
        </p>
        <button className="btn btn-info" type="button" onClick={returnCallback}>
          Return to the {referralType} referral form
        </button>
      </div>
    </div>
  );
};

export default Confirmation;
